import _ from 'lodash';
import { getNumber } from 'utils/utils';

export const readQuestions = (interaction, checked) => {
  let count = 1;

  return (_.get(interaction, 'params.questions') || []).map(
    ({ key, title, options, subtitle, mediaText, stopped, maxSelects, minSelects }) =>
      key.startsWith('_q')
        ? {
            key,
            stopped: !!stopped,
            title: `${count++}. ${title || mediaText || ''}`,
            options: (options || []).map(({ key, text }) => ({ key, text })),
            needScores: !!subtitle,
            multiSelect: getNumber(maxSelects, 1) !== 1 || getNumber(minSelects, 1) !== 1,
            checked,
          }
        : {}
  );
};

export const hasResult = question => {
  if (question && question.key && !question.stopped) {
    return !!question.options.find(it => it.checked);
  }

  return false;
};

export const hasAllResults = interaction => {
  if (interaction && interaction.questions) {
    for (const question of interaction.questions) {
      if (question && !question.stopped && !hasResult(question)) {
        return false;
      }
    }
  }

  return true;
};

export const compileResults = (questions, processOptions) => {
  const res = [];

  if (questions) {
    questions.forEach((question, questionIndex) => {
      if (question && question.key && question.checked && !question.stopped) {
        const info = { index: questionIndex, key: question.key };

        if (processOptions && hasResult(question)) {
          info.answers = [];

          if (question.needScores) {
            info.scores = [];
          }

          question.options.forEach(({ checked, score }, optionIndex) => {
            if (checked) {
              info.answers.push(optionIndex);
            }

            if (question.needScores) {
              score = parseInt(score);
              info.scores.push(isNaN(score) ? 0 : score);
            }
          });
        }

        res.push(info);
      }
    });
  }

  return res;
};
